// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchForm_form__1V1B_","input_field":"SearchForm_input_field__2CZWH"};